// extracted by mini-css-extract-plugin
module.exports = {"text_input":"styles_text_input__m42qP","error_message":"styles_error_message__3Dpkl"};